<template>
    <div class="cockpit-chart">
        <!-- TÍTULO -->
        <div class="chart-title">
            <router-link
                v-if="linked"
                div="span"
                :to="{ name: 'ven-cockpit-chart', params: { tipo: datacontent.titulo } }"
            >
                {{ title }}
            </router-link>
            <div v-else>{{ title }}</div>
        </div>

        <!-- CONTEÚDO -->
        <div ref="chartContent" class="chart-content" v-if="!noData & !loading">
            <svg class="chart_v" ref="svgcontent"></svg>
        </div>

        <!-- FOOTER -->
        <div class="chart-footer" v-if="!noData & !loading">
            <div ref="LGbox" class="legend-chart"></div>
        </div>

        <!-- MSG NÃO HÁ DADOS -->
        <div class="no-data bar" v-if="noData & !loading">
            <svg class="fail">
                <use :xlink:href="require('@/assets/img/icons/chart-error.svg') + '#layer'"></use>
            </svg>
            <div>{{ $t('chart-no-data') }}</div>
        </div>

        <!-- CARREGANDO -->
        <div class="no-data bar" v-if="loading">
            <svg class="loading">
                <use :xlink:href="require('@/assets/img/icons/loader.svg') + '#layer'"></use>
            </svg>
            <div>{{ $t('carregando') }}...</div>
        </div>
    </div>
</template>

<script>
import CockpitChart from '@/components/shared/chart/CockpitChart';
import CockpitVendasService from '@/services/CockpitVendasService';
import CockpitDespesasService from '@/services/CockpitDespesasService';
import { palette as paleta } from '@/functions/color/Palette';

export default {
    extends: CockpitChart,
    props: {
        title: {
            type: String,
            default: null,
        },
        datacontent: {
            type: Object,
            default: () => {
                return {};
            },
        },
        direction: {
            default: 'v',
        },
        linked: {
            type: Boolean,
            default: false,
        },
        module: {
            type: String,
            default: 'VENDAS', // vendas, despesas, promotor
        },
    },
    data() {
        return {
            cores: [],
            cores2: [],
            datacaption: {},
            dataset: [],
            filtered: [],
            noData: true,
            service: null,
            tooltipDiv: null,
            formatter: new Intl.NumberFormat(),
            loading: true,
        };
    },
    created() {
        if (this.module == 'DESPESAS') {
            this.service = new CockpitDespesasService(this.$http, this.$router);
        } else {
            this.service = new CockpitVendasService(this.$http, this.$router);
        }
        this.cores = paleta.getBarColors();
        this.cores2 = paleta.getAbcColor();
        let captionsize = 0;

        let needsLoad = this.datacontent.items == undefined;

        if (needsLoad) {
            this.service.getCharts(this.datacontent).then((r) => {
                this.datacontent.items = r.items;
                this.datacontent.direction = r.direction;
                this.loading = false;
                this.noData = !this.hasData(this.datacontent);

                if (!this.noData) {
                    this.$emit('resize', this.datacontent);
                    this.noData = false;

                    this.datacontent.items.forEach((val) => {
                        if (val.values.length > captionsize) {
                            this.datacaption = val;
                            this.datacaption.values.forEach((v) => (v.active = true));
                            captionsize = val.values.length;
                        }
                    });

                    setTimeout(() => {
                        this.mountChart();
                    }, 50);
                }
            });
        } else {
            this.loading = false;
            this.noData = !this.hasData(this.datacontent);

            if (!this.noData) {
                setTimeout(() => {
                    this.mountChart();
                }, 50);
            }
        }
    },
    methods: {
        svgChart() {
            var width = this.$refs.chartContent.offsetWidth;
            var height = this.$refs.chartContent.offsetHeight;
            var margin = { top: 20, right: 20, bottom: 30, left: 40 };
            var w = width - margin.left - margin.right;
            var h = height - margin.top - margin.bottom;

            let barPadding = 0.5;

            const svg = this.$d3.select(this.$refs.svgcontent);

            const chart = svg
                .append('g')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            var x0 = this.$d3.scaleBand().padding(0.1);

            var x1 = this.$d3.scaleBand().padding(0.2);

            var y = this.$d3.scaleLinear().range([h, 0]);

            var color = this.$d3.scaleOrdinal(this.cores);

            var xAxis = this.$d3.axisBottom(x0);

            var yAxis = this.$d3.axisLeft(y).tickFormat(this.customFormatter);

            this.tooltipDiv = this.$d3
                .select('body')
                .append('div')
                .attr('class', 'chart-tooltip')
                .style('opacity', 0);

            var rowgroup = this.dataset.map(function (d) {
                return d.row;
            });
            var colNames = this.dataset[0].values.map(function (d) {
                return d.name;
            });

            x0.domain(rowgroup).range([0, w]);
            x1.domain(colNames).range([0, x0.bandwidth()]);
            y.domain([
                0,
                this.$d3.max(this.dataset, (row) => {
                    return this.$d3.max(row.values, function (d) {
                        return d.value;
                    });
                }),
            ]);

            chart
                .append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0,' + h + ')')
                .call(xAxis);

            chart.append('g').attr('class', 'y axis').style('opacity', '0').call(yAxis);

            chart.select('.y').transition().duration(500).delay(1300).style('opacity', '1');

            var slice = chart
                .selectAll('.slice')
                .data(this.dataset)
                .enter()
                .append('g')
                .attr('class', 'g')
                .attr('transform', function (d) {
                    return 'translate(' + x0(d.row) + ',0)';
                });

            slice
                .selectAll('rect')
                .data(function (d) {
                    return d.values;
                })
                .enter()
                .append('rect')
                .attr('class', 'bars')
                .attr('width', x1.bandwidth())
                .attr('x', function (d) {
                    return x1(d.name);
                })
                .style('fill', (d, index) => color(d.name))
                .attr('y', function (d) {
                    return y(0);
                })
                .attr('height', function (d) {
                    return h - y(0);
                })
                .on('mouseover', (d) => {
                    this.tooltipDiv
                        .transition()
                        .duration(200)
                        .style('opacity', this.legendOpacity)
                        .style('color', '#FFF');
                    this.tooltipDiv
                        .html(d.name + ': ' + d.value)
                        .style(
                            'left',
                            this.$d3.event.pageX - this.tooltipDiv.node().offsetWidth / 2 + 'px'
                        )
                        .style('top', this.$d3.event.pageY - 40 + 'px');
                })
                .on('mousemove', (d) => {
                    this.tooltipDiv
                        .style(
                            'left',
                            this.$d3.event.pageX - this.tooltipDiv.node().offsetWidth / 2 + 'px'
                        )
                        .style('top', this.$d3.event.pageY - 40 + 'px');
                })
                .on('mouseout', (d) => {
                    this.tooltipDiv.transition().duration(500).style('opacity', 0);
                });

            slice
                .selectAll('rect')
                .transition()
                .delay(400)
                .duration(1000)
                .attr('y', function (d) {
                    return y(d.value);
                })
                .attr('height', function (d) {
                    return h - y(d.value);
                });

            slice
                .selectAll('rect')
                .transition()
                .delay(400)
                .duration(1000)
                .attr('y', function (d) {
                    return y(d.value);
                })
                .attr('height', function (d) {
                    return h - y(d.value);
                });

            var legends = this.$d3
                .select(this.$refs.LGbox)
                // var legends = chart.append("g")
                .attr('font-family', 'sans-serif')
                .attr('font-size', 10)
                .attr('text-anchor', 'end')
                .selectAll('.legend')
                .data(color.domain())
                .enter()
                .append('div')
                .attr('class', 'legend-box')
                .on('click', (d) => {
                    //
                    // Update the array to filter the chart by:
                    //

                    // add the clicked key if not included:
                    if (this.filtered.indexOf(d) == -1) {
                        this.filtered.push(d);
                        // if all bars are un-checked, reset:
                        if (this.filtered.length == color.domain().length) this.filtered = [];
                    }
                    // otherwise remove it:
                    else {
                        this.filtered.splice(this.filtered.indexOf(d), 1);
                    }
                    //
                    // Update the scales for each group(/states)'s items:
                    //
                    var newKeys = [];
                    color.domain().forEach((d) => {
                        if (this.filtered.indexOf(d) == -1 && d) {
                            newKeys.push(d);
                        }
                    });

                    x1.domain(newKeys).range([0, x0.bandwidth()]);
                    y.domain([
                        0,
                        this.$d3.max(this.dataset, (row) => {
                            return this.$d3.max(row.values, (d, key) => {
                                if (this.filtered.indexOf(d.name) == -1) return d.value;
                            });
                        }),
                    ]);

                    // update the x axis:
                    svg.select('.y')
                        .transition()
                        .call(yAxis)
                        .duration(500);

                    //
                    // Filter out the bands that need to be hidden:
                    //

                    let d3 = this.$d3;

                    let bars = slice.selectAll('.bars').data(function (d) {
                        return d.values;
                    });

                    bars.filter((d) => {
                        return this.filtered.indexOf(d.name) > -1;
                    })
                        .transition()
                        .attr('height', function (d) {
                            return 0;
                        })
                        .attr('width', function (d) {
                            return 0;
                        })
                        .attr('y', function (d) {
                            return y(0);
                        })
                        .duration(500);

                    //
                    // Adjust the remaining bars:
                    //
                    bars.filter((d) => {
                        return this.filtered.indexOf(d.name) == -1;
                    })
                        .transition()
                        .attr('x', function (d) {
                            return x1(d.name);
                        })
                        .attr('y', function (d) {
                            return y(d.value);
                        })
                        .attr('height', function (d) {
                            return h - y(d.value);
                        })
                        .attr('width', (d) => {
                            return x1.bandwidth();
                        })
                        .attr('fill', function (d) {
                            return color(d.name);
                        })
                        .duration(500);

                    // update legend:
                    legends.style('opacity', (d) => {
                        if (this.filtered.length) {
                            if (this.filtered.indexOf(d) == -1) {
                                return 1;
                            } else {
                                return 0.4;
                            }
                        } else {
                            return 1;
                        }
                    });
                });

            legends
                .append('div')
                .style('min-width', this.legendRectSize + 'px')
                .style('height', this.legendRectSize + 'px')
                .attr('class', 'legend-color-box')
                .style('background', color);

            legends
                .append('div')
                .style('text-transform', 'uppercase')
                .text(function (d) {
                    return d;
                });
        },
        svgChartHor() {
            var width = this.$refs.chartContent.offsetWidth;
            var height = this.$refs.chartContent.offsetHeight;
            var margin = { top: 20, right: 20, bottom: 30, left: 40 };
            var w = width - margin.left - margin.right;
            var h = height - margin.top - margin.bottom;

            const svg = this.$d3.select(this.$refs.svgcontent);
            var color = this.$d3.scaleOrdinal(this.cores);

            const chart = svg
                .append('g')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            var x = this.$d3.scaleLinear().range([0, w]);

            var y0 = this.$d3.scaleBand().padding(0.1);

            var y1 = this.$d3.scaleBand().padding(0.2);

            var xAxis = this.$d3.axisBottom(x).tickFormat(this.customFormatter);

            var yAxis = this.$d3.axisLeft(y0);

            var div = this.$d3
                .select('body')
                .append('div')
                .attr('class', 'chart-tooltip')
                .style('opacity', 0);

            var colgroup = this.dataset.map(function (d) {
                return d.row;
            });
            var rowNames = this.dataset[0].values.map(function (d) {
                return d.name;
            });

            y0.domain(colgroup).range([h, 0]);
            y1.domain(rowNames).range([y0.bandwidth(), 0]);
            x.domain([
                0,
                this.$d3.max(this.dataset, (row) => {
                    return this.$d3.max(row.values, function (d) {
                        return d.value;
                    });
                }),
            ]);

            chart
                .append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0,' + h + ')')
                .call(xAxis);

            chart.append('g').attr('class', 'y axis').style('opacity', '0').call(yAxis);

            chart.select('.y').transition().duration(500).delay(1300).style('opacity', '1');

            var slice = chart
                .selectAll('.slice')
                .data(this.dataset)
                .enter()
                .append('g')
                .attr('class', 'g')
                .attr('transform', function (d) {
                    return 'translate(0, ' + y0(d.row) + ')';
                });

            slice
                .selectAll('rect')
                .data(function (d) {
                    return d.values;
                })
                .enter()
                .append('rect')
                .attr('class', 'bars')
                .attr('width', function (d) {
                    return 0;
                })
                .attr('x', function (d) {
                    return 0;
                })
                .style('fill', (d, index) => /*this.cores[index] */ color(d.name))
                .attr('y', function (d) {
                    return y1(d.name);
                })
                .attr('height', y1.bandwidth())
                .on('mouseover', (d) => {
                    div.transition()
                        .duration(200)
                        .style('opacity', this.legendOpacity)
                        .style('color', '#FFF');
                    div.html(d.name + ': ' + d.value)
                        .style('left', this.$d3.event.pageX - div.node().offsetWidth / 2 + 'px')
                        .style('top', this.$d3.event.pageY - 40 + 'px');
                })
                .on('mousemove', (d) => {
                    div.style(
                        'left',
                        this.$d3.event.pageX - div.node().offsetWidth / 2 + 'px'
                    ).style('top', this.$d3.event.pageY - 40 + 'px');
                })
                .on('mouseout', (d) => {
                    div.transition().duration(500).style('opacity', 0);
                });

            slice
                .selectAll('rect')
                .transition()
                .delay(400)
                .duration(1000)
                .attr('width', function (d) {
                    return x(d.value);
                });

            var legends = this.$d3
                .select(this.$refs.LGbox)
                .attr('font-family', 'sans-serif')
                .attr('font-size', 10)
                .attr('text-anchor', 'end')
                .selectAll('.legend')
                .data(color.domain())
                .enter()
                .append('div')
                .attr('class', 'legend-box')
                .on('click', (d) => {
                    //
                    // Update the array to filter the chart by:
                    //

                    // add the clicked key if not included:
                    if (this.filtered.indexOf(d) == -1) {
                        this.filtered.push(d);
                        // if all bars are un-checked, reset:
                        if (this.filtered.length == color.domain().length) this.filtered = [];
                    }
                    // otherwise remove it:
                    else {
                        this.filtered.splice(this.filtered.indexOf(d), 1);
                    }
                    //
                    // Update the scales for each group(/states)'s items:
                    //
                    var newKeys = [];
                    color.domain().forEach((d) => {
                        if (this.filtered.indexOf(d) == -1 && d) {
                            newKeys.push(d);
                        }
                    });

                    y1.domain(newKeys).range([y0.bandwidth(), 0]);
                    x.domain([
                        0,
                        this.$d3.max(this.dataset, (row) => {
                            return this.$d3.max(row.values, (d, key) => {
                                if (this.filtered.indexOf(d.name) == -1) return d.value;
                            });
                        }),
                    ]);

                    // update the x axis:
                    svg.select('.x')
                        .transition()
                        .call(xAxis)
                        .duration(500);

                    //
                    // Filter out the bands that need to be hidden:
                    //

                    let d3 = this.$d3;

                    let bars = slice.selectAll('.bars').data(function (d) {
                        return d.values;
                    });

                    bars.filter((d) => {
                        return this.filtered.indexOf(d.name) > -1;
                    })
                        .transition()
                        .attr('x', function (d) {
                            return 0;
                        })
                        .attr('height', function (d) {
                            return 0;
                        })
                        .attr('width', function (d) {
                            return 0;
                        })
                        .attr('y', function (d) {
                            return +d3.select(this).attr('y') + +d3.select(this).attr('height') / 2;
                        })
                        .duration(500);

                    //
                    // Adjust the remaining bars:
                    //
                    bars.filter((d) => {
                        return this.filtered.indexOf(d.name) == -1;
                    })
                        .transition()
                        .attr('x', function (d) {
                            return 0;
                        })
                        .attr('y', function (d) {
                            return y1(d.name);
                        })
                        .attr('height', y1.bandwidth())
                        .attr('width', function (d) {
                            return x(d.value);
                        })
                        .attr('fill', function (d) {
                            return color(d.key);
                        })
                        .duration(500);

                    // update legend:
                    legends.style('opacity', (d) => {
                        if (this.filtered.length) {
                            if (this.filtered.indexOf(d) == -1) {
                                return 1;
                            } else {
                                return 0.4;
                            }
                        } else {
                            return 1;
                        }
                    });
                });

            legends
                .append('div')
                .style('width', this.legendRectSize + 'px')
                .style('height', this.legendRectSize + 'px')
                .attr('class', 'legend-color-box')
                .style('background', color);

            legends
                .append('p')
                .style('text-transform', 'uppercase')
                .text(function (d) {
                    return d;
                });
        },
        svgChartAbc() {
            let total = this.dataset[0].values.length;
            let numOfClientsA = Math.round((total * 20) / 100);
            let numOfClientsB = Math.round((total * 30) / 100);

            this.dataset[0].values.forEach((d, i) => {
                if (i < numOfClientsA) {
                    d.colorname = 'A';
                } else if (i < numOfClientsB + numOfClientsA) {
                    d.colorname = 'B';
                } else {
                    d.colorname = 'C';
                }
            });

            var width = this.$refs.chartContent.offsetWidth;
            var height = this.$refs.chartContent.offsetHeight;
            var margin = { top: 20, right: 20, bottom: 30, left: 40 };
            var w = width - margin.left - margin.right;
            var h = height - margin.top - margin.bottom;

            let barPadding = 0.5;

            const svg = this.$d3.select(this.$refs.svgcontent);

            const chart = svg
                .append('g')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            var x0 = this.$d3.scaleBand().padding(0.1);

            var x1 = this.$d3.scaleBand().padding(0.2);

            var y = this.$d3.scaleLinear().range([h, 0]);

            var color = this.$d3.scaleOrdinal(this.cores);
            var colorGroup = this.$d3.scaleOrdinal(this.cores2);

            var xAxis = this.$d3.axisBottom(x0);

            var yAxis = this.$d3.axisLeft(y).tickFormat(this.customFormatter);

            this.tooltipDiv = this.$d3
                .select('body')
                .append('div')
                .attr('class', 'chart-tooltip')
                .style('opacity', 0);

            var rowgroup = this.dataset.map(function (d) {
                return d.row;
            });
            var colNames = this.dataset[0].values.map(function (d) {
                return d.name;
            });

            x0.domain(rowgroup).range([0, w]);
            x1.domain(colNames).range([0, x0.bandwidth()]);
            y.domain([
                0,
                this.$d3.max(this.dataset, (row) => {
                    return this.$d3.max(row.values, function (d) {
                        return d.value;
                    });
                }),
            ]);

            chart
                .append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0,' + h + ')')
                .call(xAxis);

            chart.append('g').attr('class', 'y axis').style('opacity', '0').call(yAxis);

            chart.select('.y').transition().duration(500).delay(1300).style('opacity', '1');

            var slice = chart
                .selectAll('.slice')
                .data(this.dataset)
                .enter()
                .append('g')
                .attr('class', 'g')
                .attr('transform', function (d) {
                    return 'translate(' + x0(d.row) + ',0)';
                });

            slice
                .selectAll('rect')
                .data(function (d) {
                    return d.values;
                })
                .enter()
                .append('rect')
                .attr('class', 'bars')
                .attr('width', x1.bandwidth())
                .attr('x', function (d) {
                    return x1(d.name);
                })
                .style('fill', (d, index) => {
                    color(d.name);
                    return colorGroup(d.colorname);
                })
                .attr('y', function (d) {
                    return y(0);
                })
                .attr('height', function (d) {
                    return h - y(0);
                })
                .on('mouseover', (d) => {
                    this.tooltipDiv
                        .transition()
                        .duration(200)
                        .style('opacity', this.legendOpacity)
                        .style('color', '#FFF');
                    this.tooltipDiv
                        .html(d.name + ': ' + d.value)
                        .style(
                            'left',
                            this.$d3.event.pageX - this.tooltipDiv.node().offsetWidth / 2 + 'px'
                        )
                        .style('top', this.$d3.event.pageY - 40 + 'px');
                })
                .on('mousemove', (d) => {
                    this.tooltipDiv
                        .style(
                            'left',
                            this.$d3.event.pageX - this.tooltipDiv.node().offsetWidth / 2 + 'px'
                        )
                        .style('top', this.$d3.event.pageY - 40 + 'px');
                })
                .on('mouseout', (d) => {
                    this.tooltipDiv.transition().duration(500).style('opacity', 0);
                });

            slice
                .selectAll('rect')
                .transition()
                .delay(400)
                .duration(1000)
                .attr('y', function (d) {
                    return y(d.value);
                })
                .attr('height', function (d) {
                    return h - y(d.value);
                });

            slice
                .selectAll('rect')
                .transition()
                .delay(400)
                .duration(1000)
                .attr('y', function (d) {
                    return y(d.value);
                })
                .attr('height', function (d) {
                    return h - y(d.value);
                });

            var legends = this.$d3
                .select(this.$refs.LGbox)
                .attr('font-family', 'sans-serif')
                .attr('font-size', 10)
                .attr('text-anchor', 'end')
                .selectAll('.legend')
                .data(color.domain())
                .enter()
                .append('div')
                .attr('class', 'legend-box')
                .on('click', (d) => {
                    //
                    // Update the array to filter the chart by:
                    //

                    // add the clicked key if not included:
                    if (this.filtered.indexOf(d) == -1) {
                        this.filtered.push(d);
                        // if all bars are un-checked, reset:
                        if (this.filtered.length == color.domain().length) this.filtered = [];
                    }
                    // otherwise remove it:
                    else {
                        this.filtered.splice(this.filtered.indexOf(d), 1);
                    }
                    //
                    // Update the scales for each group(/states)'s items:
                    //
                    var newKeys = [];
                    color.domain().forEach((d) => {
                        if (this.filtered.indexOf(d) == -1 && d) {
                            newKeys.push(d);
                        }
                    });

                    x1.domain(newKeys).range([0, x0.bandwidth()]);
                    y.domain([
                        0,
                        this.$d3.max(this.dataset, (row) => {
                            return this.$d3.max(row.values, (d, key) => {
                                if (this.filtered.indexOf(d.name) == -1) return d.value;
                            });
                        }),
                    ]);

                    // update the x axis:
                    svg.select('.y')
                        .transition()
                        // .call(this.$d3.axisBottom(x).ticks(null, "s"))
                        .call(yAxis)
                        .duration(500);

                    //
                    // Filter out the bands that need to be hidden:
                    //

                    let d3 = this.$d3;

                    let bars = slice.selectAll('.bars').data(function (d) {
                        return d.values;
                    });

                    bars.filter((d) => {
                        return this.filtered.indexOf(d.name) > -1;
                    })
                        .transition()
                        .attr('height', function (d) {
                            return 0;
                        })
                        .attr('width', function (d) {
                            return 0;
                        })
                        .attr('y', function (d) {
                            return y(0);
                        })
                        .duration(500);

                    //
                    // Adjust the remaining bars:
                    //
                    bars.filter((d) => {
                        return this.filtered.indexOf(d.name) == -1;
                    })
                        .transition()
                        .attr('x', function (d) {
                            return x1(d.name);
                        })
                        .attr('y', function (d) {
                            return y(d.value);
                        })
                        .attr('height', function (d) {
                            return h - y(d.value);
                        })
                        .attr('width', (d) => {
                            return x1.bandwidth();
                        })
                        .attr('fill', function (d) {
                            return color(d.name);
                        })
                        .duration(500);

                    // update legend:
                    legends.style('opacity', (d) => {
                        if (this.filtered.length) {
                            if (this.filtered.indexOf(d) == -1) {
                                return 1;
                            } else {
                                return 0.4;
                            }
                        } else {
                            return 1;
                        }
                    });
                });

            legends
                .append('div')
                .style('min-width', this.legendRectSize + 'px')
                .style('height', this.legendRectSize + 'px')
                .attr('class', 'legend-color-box')
                .style('background', (d, i) => {
                    if (i < numOfClientsA) {
                        return colorGroup('A');
                    } else if (i < numOfClientsB + numOfClientsA) {
                        return colorGroup('B');
                    } else {
                        return colorGroup('C');
                    }
                });

            legends
                .append('div')
                .style('text-transform', 'uppercase')
                .text(function (d) {
                    return d;
                });
        },
        hideData(d, i) {
            d.active = !d.active;
        },
        hasData(content) {
            if (content.items != undefined && content.items.length > 0) {
                return content.items[0].values.length > 0;
            } else {
                return false;
            }
        },
        mountChart() {
            this.dataset = [...this.datacontent.items];

            if (!this.dataset || this.dataset.length <= 0) {
                this.noData = true;
            } else {
                this.dataset[0].values = this.dataset[0].values.filter((e) => {
                    return e.value > 0;
                });

                this.noData = this.dataset[0].values.length < 1;

                if (!this.noData) {
                    setTimeout(() => {
                        if (this.datacontent.direction == 'v') {
                            this.svgChart();
                        } else if (this.datacontent.direction == 'd') {
                            this.svgChartHor();
                        } else if (this.datacontent.direction == 'abc') {
                            this.svgChartAbc();
                        }
                    }, 10);
                }
            }
        },
        redrawChart(clean = true) {
            if (clean) {
                this.cleanChart();
            }

            this.$emit('resize', this.datacontent);
            setTimeout(this.mountChart, 10);
        },
        cleanChart() {
            this.$d3.select(this.$refs.svgcontent).selectAll('g').remove();
            this.$d3.select(this.$refs.LGbox).selectAll('.legend-box').remove();

            if (this.tooltipDiv) {
                this.tooltipDiv.remove();
            }
        },
        customFormatter(number) {
            let p = this.formatter.formatToParts(number);

            let g = p.filter((e) => {
                return e.type == 'group';
            });

            if (g.length < 1) {
                return this.formatter.format(number);
            } else {
                let sufix = '';
                let value = '';

                if (p[0].value.length == 3) {
                    value = p[0].value;
                } else {
                    value = `${p[0].value}${
                        p[0].value.length < 2 ? this.$t('scale-separator') : ''
                    }${p[2].value.substring(0, 2 - p[0].value.length)}`;
                }

                switch (g.length) {
                    case 1:
                        sufix = 'k';
                        break;
                    case 2:
                        sufix = 'M';
                        break;
                    case 3:
                        sufix = 'B';
                        break;
                    case 4:
                        sufix = 'T';
                        break;
                }

                return `${value}${sufix}`;
            }
        },
    },
};
</script>

<style lang="scss">
.axis {
    @include defaultFont();
    font-weight: 600;
    color: $darker-gray-color;
}

.legend-box > :not(.legend-color-box) {
    color: $darker-gray-color;
}
</style>
